/**
 * message-tag.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

export enum MessageTag {
    // NOTE: I generally encourage putting tags for new or experimental requests
    // at the top, because (1) they're easily located, and (2) negative tag
    // values are more obviously not finalized, when seen in the protocol.

    PVT_INTERNAL = -1, // (never transmitted)

    PVT_INVALID = 0, // (never transmitted)

    REQ_VERSION = 1,
    RSP_VERSION,
    RSP_ACKNOWLEDGEMENT,

    PVT_BINARY = 4,
    // RESERVED = 5-6

    REQ_PING = 7,

    RSP_CFG_USER = 8,
    RSP_CFG_ZONE,
    REQ_CFG_APP,
    RSP_CFG_APP,
    REQ_STATUS_APP,
    RSP_STATUS_APP,
    REQ_STATUS_CLIENTS,
    RSP_STATUS_CLIENTS,

    // RESERVED = 16-23

    REQ_LOGIN = 24,
    REQ_AUTH_TOKEN,
    RSP_AUTH_TOKEN,
    REQ_AUTH_TOKEN_LOGIN,
    UP_DISCONNECT,
    DOWN_DISCONNECT,
    RSP_ACTIVE_SESSIONS,
    REQ_TERMINATE_ACTIVE_SESSIONS,

    RSP_WATCHLIST = 32,
    REQ_WATCH_SUBJECT_CONTEXT,
    RSP_WATCHLIST_ITEM_UPDATED,
    REQ_WATCHLIST_ITEM,
    REQ_STOP_WATCHING,
    RSP_STOP_WATCHING,
    REQ_EDIT_WATCHLIST_ITEM,
    REQ_REFRESH_WATCHLIST_ITEM,
    REQ_ACKNOWLEDGE_WATCHLIST_ALERT,
    REQ_GROUP_WORKLISTS,
    RSP_GROUP_WORKLISTS,
    REQ_SHARED_WORKLIST,
    REQ_CREATE_SHARED_WORKLIST,
    REQ_EDIT_SHARED_WORKLIST,

    // RESERVED = 45-47

    RSP_REMINDERS = 48,
    REQ_ADD_REMINDER,
    REQ_DELETE_REMINDER,

    // RESERVED = 51-52
    REQ_REMINDER_LINKED_ITEM = 53,

    RSP_SUBJECT_CONTEXT_SEARCH_TREE = 54,
    REQ_SUBJECT_CONTEXT_SEARCH,
    RSP_SUBJECT_CONTEXT_SEARCH,
    REQ_SUBJECT_CONTEXT_SEARCH_RESULT,
    REQ_ADDITIONAL_SEARCH_RESULTS,

    // RESERVED = 59-60

    RSP_SUBJECT_CONTEXT = 61,
    REQ_RELEASE_OBJECT,

    // RESERVED = 63

    RSP_CFG_RELATIONSHIPS = 64,
    RSP_SUBJECT_CONTEXT_RELATIONSHIPS,
    REQ_RELATIONSHIP_PARTNER,
    REQ_RELATION_GRAPH,
    REQ_RELATION_GRAPH_EXPANSION,
    REQ_RELATION_GRAPH_SUBJECT_CONTEXT,
    RSP_RELATION_GRAPH,

    // RESERVED = 71

    REQ_LOAD_ALGORITHM = 72,
    REQ_START_ALGORITHM,
    RSP_NEXT_STEPS,
    UP_SUBMIT_ANSWERS,
    REQ_ADDITIONAL_STEPS,
    BCST_ALGORITHM_USERS,
    REQ_STOP_ALGORITHM,
    RSP_STOP_ALGORITHM,
    BCST_RESTART_ALGORITHM,

    // RESERVED = 81-83

    REQ_EXPLANATION = 84,
    RSP_EXPLANATION,
    REQ_PREDECESSOR_STEPS,
    RSP_PREDECESSOR_STEPS,
    REQ_SUCCESSOR_STEPS,
    RSP_SUCCESSOR_STEPS,
    REQ_STEP_DEFINITIONS,

    // RESERVED = 91-93

    DEP_REQ_ADD_STEP_COMMENT = 94,
    DEP_REQ_MODIFY_STEP_COMMENT,
    DEP_REQ_DELETE_STEP_COMMENT,
    RSP_COMMENT,
    REQ_ADD_COMMENT,
    REQ_MODIFY_COMMENT,
    REQ_DELETE_COMMENT,

    // RESERVED = 101-103

    REQ_POST_CHAT_MESSAGE = 104,
    BCST_CHAT_MESSAGE,

    // RESERVED = 106-107

    REQ_SAVE_SUBJECT_CONTEXT = 108,
    REQ_CREATE_SUBJECT_CONTEXT,
    REQ_REFER_SUBJECT_CONTEXT,
    REQ_INCREASE_SUBJECT_CONTEXT_VISIBILITY,
    RSP_SAVE,

    // RESERVED = 113-115

    REQ_STATUS_AGGREGATOR = 116,
    RSP_STATUS_AGGREGATOR,
    REQ_STATUS_DATA_EXPORT,
    RSP_STATUS_DATA_EXPORT,

    // RESERVED = 120-127

    REQ_SEND_PASSWORD_RESET_EMAIL = 128,
    REQ_BEGIN_PASSWORD_RESET,
    SREQ_CREDENTIAL_CHALLENGE,
    CRSP_CREDENTIAL_CHALLENGE,
    SREQ_NEW_PASSWORD,
    CRSP_NEW_PASSWORD,
    REQ_CHANGE_PASSWORD,
    SREQ_MODIFY_SECURITY_QUESTIONS,
	CRSP_MODIFY_SECURITY_QUESTIONS,
	
	// RESERVED = 137-199

    REQ_ADD_SUBJECT_CONTEXT_RELATIONSHIP = 200,
    REQ_MODIFY_SUBJECT_CONTEXT_RELATIONSHIP,
    REQ_DELETE_SUBJECT_CONTEXT_RELATIONSHIP,

    // RESERVED = 203-255
    // (begin 2-byte values)

    RSP_AVAILABLE_AGGREGATORS = 256,
    REQ_CREATE_AGGREGATOR,
    RSP_CREATE_AGGREGATOR,
    REQ_START_AGGREGATOR,
    RSP_AGGREGATOR_REPORT,
    REQ_DELETE_AGGREGATOR,
    REQ_PAUSE_AGGREGATOR,
    REQ_RESUME_AGGREGATOR,
    REQ_CANCEL_AGGREGATION,
    RSP_AGGREGATOR_FAILURE,
    REQ_AGGREGATION_SUBJECT_CONTEXT,

    // RESERVED = 267-278

    RSP_AVAILABLE_DATA_EXPORTS = 279,
    REQ_CREATE_DATA_EXPORT,
    RSP_CREATE_DATA_EXPORT,
    REQ_START_DATA_EXPORT,
    // 283 removed as duplicate
    REQ_DELETE_DATA_EXPORT = 284,
    REQ_PAUSE_DATA_EXPORT,
    REQ_RESUME_DATA_EXPORT,
    REQ_CANCEL_DATA_EXPORT,
    RSP_DATA_EXPORT_FAILURE,
    RSP_DATA_EXPORT_REPORT,
    RSP_START_DATA_EXPORT,

    REQ_REFRESH_REPORT_SCHEMAS = 291,
    RSP_REFRESH_REPORT_SCHEMAS,
    REQ_SAVE_DATA_EXPORT_SCHEMA,
    RSP_SAVE_REPORT_SCHEMA,
    REQ_SAVE_AGGREGATION_SCHEMA,
    REQ_DELETE_DATA_EXPORT_SCHEMA,
    REQ_DELETE_AGGREGATION_SCHEMA,
    REQ_CHANGE_DATA_EXPORT_SCHEMA_VISIBILITY,
    REQ_CHANGE_AGGREGATION_SCHEMA_VISIBILITY,

    // RESERVED 300-327

    REQ_START_GUEST_SESSION = 328,
    RSP_START_GUEST_SESSION,

    // RESERVED 329-359

    REQ_EXTENSION_SIGNAL = 360,
    BCST_EXTENSION_SIGNAL,

    // RESERVED 362-503

    DOWN_NOTIFY = 504,
    REQ_ANNOUNCEMENT,
    BCST_ANNOUNCEMENT,

    // RESERVED = 507-508

    REQ_KILL_CLIENT = 509,
    BCST_ADMIN_CLIENT_LIST,
    REQ_CFG_QUARANTINE,
    RSP_CFG_QUARANTINE,
    REQ_SHUTDOWN,
    RSP_SHUTDOWN,
    REQ_QUARANTINE_ZONE,

    // RESERVED = 516-527

    REQ_CREATE_GROUP = 528,
    REQ_EDIT_GROUP,

    // RESERVED = 530-549

	REQ_GROUP_USERS = 550,
	RSP_GROUP_USERS,
	REQ_USER,
	REQ_CHANGE_USER_ACTIVE_STATUS,
	RSP_USER,
	REQ_EDIT_USER = 555,

    // RESERVED = 556-999
    REQ_RESET_USER_PASSWORD,
    REQ_CREATE_USER,
    REQ_EDIT_OTHER_USER,
    REQ_SET_USER_GROUPS,
    REQ_REMOVE_USER_GROUPS,

    DBG_UP_BREAKPOINT = 1000,
    DBG_REQ_CFG_MODE,
    DBG_REQ_CFG_CODE_GEN_MODE,

    // RESERVED = 1002-1023F

    DBG_UP_LOG = 1024,
    DBG_DOWN_LOG,

    // RESERVED = 1026-1071

    DBG_REQ_RESTART_ALGORITHM = 1072,

    // RESERVED ≥ 1073
    // _top_ = 2047
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/message-tag.ts